import React, { useState, useEffect } from 'react';
import { InstitutionQuery } from './query/InstitutionQuery';
import InstitutionCard from '../institution/InstitutionCard';
import Slider from 'react-slick';
import {Typography} from "@mui/material";

const EstablishmentListByCommunity = ({ communityId }) => {
    const [institutions, setInstitutions] = useState([]);

    useEffect(() => {
        const fetchInstitutions = async () => {
            const institutions = await InstitutionQuery.getInstitutionsByCommunity(communityId);
            setInstitutions(institutions);
        };

        fetchInstitutions();
    }, [communityId]);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: institutions.length < 3 ? institutions.length : 3,
        centerPadding: '-15px',
        centerMode: true,
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1,
                    variableWidth : false,
                    arrows : false
                },
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    variableWidth : false,
                    centerPadding: '0px',
                },
            }
        ],
        variableWidth : false
    };

    return (
        <div>
            <Typography variant={'subtitle2'}>Etablissements</Typography>
            <Slider {...settings}>
                {institutions.map((institution, index) => (
                    <InstitutionCard key={index} institution={institution} />
                ))}
            </Slider>
            {
                institutions.length === 0 && <Typography variant={'subtitle3'}>Aucun établissement trouvé</Typography>
            }
        </div>
    );
};

export default EstablishmentListByCommunity;
